/**
 * Full-width error strip directly beneath a failing row, opened as its own
 * <tr> in Table.jsx's row-mapping loop (not an overlay/toast). Shared by
 * CalendarsPage and AlertsPage — was two identical copies.
 */
import React from "react";
import Icon from "../../theme/untitled/icons/Icon";
import Button from "../../theme/untitled/Button/Button";
import styles from "./RowErrorStrip.module.scss";

const RowErrorStrip = ({ item, message, onRetry, onDismiss, colSpan }) => (
  <tr>
    <td colSpan={colSpan} className={styles.errorCell}>
      <div className={styles.errorStrip}>
        <Icon name="AlertTriangle" className={styles.errorStripIcon} />
        <span className={styles.errorStripText}>
          <span className={styles.errorStripName}>{item.name}</span> couldn&rsquo;t be
          {item.available ? " unpublished" : " published"}: {message}
        </span>
        <span className={styles.errorStripActions}>
          <Button hierarchy="tertiary" size="sm" onClick={onRetry}>
            Try again
          </Button>
          <Button hierarchy="tertiary" size="sm" onClick={onDismiss}>
            Dismiss
          </Button>
        </span>
      </div>
    </td>
  </tr>
);

export default RowErrorStrip;
